import React from 'react';
import classNames from './leaderboard-reward-item.module.css';
import { cn } from '@wwe-portal/ui/lib/lib';
import { useResponsive } from '@wwe-portal/ui/hooks/use-responsive';
import { Textfit } from 'react-textfit';

interface RewardRankContainerProps {
  rank: string;
  rankInfoElement: React.ReactNode;
  rewardsElement: React.ReactNode;
  highlight?: boolean;
}

export const RewardRankContainer = ({
  rank,
  rankInfoElement,
  rewardsElement,
  highlight,
}: RewardRankContainerProps) => {
  const { isMobile } = useResponsive();
  return (
    <div className={classNames.container}>
      {highlight && <div className={classNames.highlight} />}
      <div
        className={cn(classNames.rank, {
          [classNames.rankHighlight!]: highlight,
        })}
      >
        <Textfit max={12} className="w-full" mode="single">
          {rank}
        </Textfit>
      </div>
      {rankInfoElement && (
        <div className={classNames.rankInfo}>{rankInfoElement}</div>
      )}
      <div
        className={
          isMobile
            ? classNames.rewardsContainerMobile
            : classNames.rewardsContainerDesktop
        }
      >
        {rewardsElement}
      </div>
    </div>
  );
};
